<template>
  <div class="grid-2-columns gap-4">
    <div v-for="metric in metrics" :key="metric.name" class="d-flex flex-row align-center gap-1">
      <span class="font-size-14 font-weight-medium">{{ metric.name }}:</span>
      <span class="font-size-22"> {{ formatMetricValue(metric.value) }} {{ currentSections[metric.name].name }} </span>
    </div>
  </div>
</template>

<script>
import { PropOptions } from 'vue'
import { Method, Computed } from '@/_typedefs'
import { Metric, MetricSection } from './SideResult.vue'

export default {
  props: {
    /** @type {PropOptions<Metric[]>} */
    metrics: {
      type: Array,
      required: true,
    },
    /** @type {PropOptions<Record<string, MetricSection>>} */
    currentSections: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /** @type {Method<[value: number], number>} */
    formatMetricValue(value) {
      return Intl.NumberFormat('en-US', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value)
    },
  },
}
</script>

<style></style>
